<template lang="pug">
  .wrapper-supervisor-list
    h2 responsáveis

    .add-supervisor
      .total
        span total de {{ $wp('supervisor') }}: {{ totalSupervisors }}
      .button
        PButton(color="warning", size="md", @click="createNew") criar novo {{ $ws('supervisor') }}

    .table
      SmartTable(name="supervisor-list", v-bind="table", v-model="tableData", ref="table")
        template(v-slot:default="slotProps")
          TableRow(v-bind="slotProps")

            template(v-slot:name="{ columnValue }")
              span.no-wrap(:title="columnValue") {{ columnValue }}

            template(v-slot:email="{ columnValue }")
              span.no-wrap(:title="columnValue") {{ columnValue }}

            template(v-slot:code="{ columnValue, rowItem, index }")
              span.no-wrap(:title="columnValue") {{ columnValue }}

            template(v-slot:companies="{ columnValue, rowItem, index }")
              template(v-if="!reloadingSupervisorInfo")
                span(v-if="columnValue.length > 1") vários
                span(v-else-if="columnValue.length === 1") {{ columnValue[0].name }}
                span(v-else) nenhum
              .loading-field(v-else key="loading-company")

            template(v-slot:groups="{ columnValue, rowItem, index }")
              template(v-if="!reloadingSupervisorInfo")
                span(v-if="columnValue.length > 1") vários
                span(v-else-if="columnValue.length === 1") {{ columnValue[0].name }}
                span(v-else) nenhum
              .loading-field(v-else key="loading-groups")

            template(v-slot:employees="{ columnValue, rowItem, index }")
              template(v-if="!reloadingSupervisorInfo") {{ columnValue.length }}
              .loading-field(v-else key="loading-employees")

        template(v-slot:detailsBox="{item}")
          Details(:supervisor="item", @reloadTable="updateTable")
</template>

<script>
import { includesSearch } from 'src/utils'
import Details from './Details'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'SupervisorList',
  mounted () {
    this.updateTable()
    setAmplitudeEvent('lista responsaveis', {})
  },
  data () {
    return {
      reloadingSupervisorInfo: false,
      selectedSupervisor: {
        index: null,
        item: null
      },
      table: {
        headerItems: [
          {column: 'nome', field: 'name', width: '1fr'},
          {column: 'email', field: 'email', width: '1fr'},
          {column: 'código', field: 'code', width: '0.6fr'},
          {
            column: this.$wp('companyShortName'),
            field: 'companies',
            width: '1fr',
            filterFunction: ({search, item}) => includesSearch(item.companies[0].name, search)
          },
          {
            column: 'grupos',
            field: 'groups',
            width: '1fr',
            filterFunction: ({search, item}) => includesSearch(item.groups[0].name, search)
          },
          {
            column: 'nº de ' + this.$wp('employee'),
            field: 'employees',
            width: '1fr',
            filterFunction: ({search, item}) => parseInt(search) === item.employees.length
          }
        ],
        config: {
          startFocusedSearch: 'name',
          defaultSortField: 'name',
          defaultColumnSearch: 'name'
        }
      }
    }
  },
  computed: {
    totalSupervisors () {
      return this.$store.state.common.supervisors.items.length
    },
    tableData: {
      get () {
        return {loaded: this.$store.state.common.supervisors.items}
      },
      set ({selected}) {
        this.selectedSupervisor = selected
      }
    }
  },
  methods: {
    async updateTable (reloadAllSupervisor = false) {
      this.reloadingSupervisorInfo = true
      this.closeDetailsTable()

      await this.$store.dispatch('common/supervisors/fetchItems', {
        withFields: [
          'email', 'code', 'companies', 'groups',
          'employees', 'employers', 'phone', 'cell_phone'
        ],
        fullReload: reloadAllSupervisor
      })

      this.reloadingSupervisorInfo = false
    },
    closeDetailsTable () {
      this.$refs.table.closeDetailsBox()
    },
    createNew () {
      this.$router.push('/supervisor/new')
    }
  },
  components: {Details}
}
</script>

<style scoped lang="scss">
.wrapper-supervisor-list {
  h2{
    text-align: center;
  }

  .add-supervisor {
    grid-row: 2;
    margin-bottom: 15px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    align-items: center;
    grid-template-areas:
      "total . . button";

    .button { grid-area: button; justify-self: end; }
    .total { grid-area: total }
  }

  .table {
    // border: 1px solid black;
    grid-row: 3;
    width: 100%;
    height: 100%;
    padding-bottom: 10px;

    .loading-field {
      width: 30%;
      height: 60%;
      background-color: lightgray;
    }
  }
}
</style>
